module.exports = __webpack_public_path__ + "static/media/shield.08016504.svg";